// TODO uncomment "drop_console" in src/build/terser.config.json

(function($) {
    $(function () {
        $('[data-bs-toggle="tooltip"]').tooltip();

        $('[data-bs-toggle="tooltip"]').on('click', function () {
            $(this).tooltip('hide');
        });
    })

    const modalSearch = document.getElementById('modalSearch');
    const inputSearch = document.getElementById('search');

    modalSearch.addEventListener('shown.bs.modal', () => {
        inputSearch.focus();
    })

    ////
    // show/hide on scroll

    const navBottom = document.getElementById('okt-nav-bottom');
    const logoNavRail = document.getElementById('okt-logo-desktop');
    const goToUp = document.getElementById('okt-gotoup');

    const scrollOffset = 0;

    // const scrollElement = document.querySelector(".js-scroll");

    const scrollBelowViewHeight = (el, offset = 0) => {
        return (
            window.scrollY >= ( (window.innerHeight || document.documentElement.clientHeight) - offset ) / 2
        );
    };

    const scrollNavHeight = (el, offset = 0) => {
        return (
            window.scrollY >= 80 && ( (window.innerWidth || document.documentElement.clientWidth) >= 992 )
        );
    };

    const displayScrollElement = ( el, className ) => {
        el.classList.add( className );
    }
    const hideScrollElement = ( el, className ) => {
        el.classList.remove( className );
    }

    const handleScrollNavBottom = ( el ) => {
        if (scrollBelowViewHeight(el, scrollOffset)) {
            displayScrollElement( el, 'okt-scrolled-bottom' );
        } else {
            hideScrollElement( el, 'okt-scrolled-bottom' );
        }
    }

    const handleScrollLogoNavRail = ( el ) => {
        if (scrollNavHeight(el, scrollOffset)) {
            displayScrollElement( el, 'okt-show' );
        } else {
            hideScrollElement( el, 'okt-show' );
        }
    }

    if ( navBottom !== null ){
        window.addEventListener('scroll', () => {
            handleScrollNavBottom( navBottom );
        });
    }
    if ( logoNavRail !== null ){
        window.addEventListener('scroll', () => {
            handleScrollLogoNavRail( logoNavRail );
        });
    }
    if ( goToUp !== null ){
        window.addEventListener('scroll', () => {
            handleScrollNavBottom( goToUp );
        });
        goToUp.addEventListener('click', () => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        });
    }

    ////
    // infinity footer: in Jetpack plugin, it shows if window.pageYOffset >= 350, but only change bottom position between 0 or -50px
    // overwrite behaviour
    //
    //
    //
    // const infiniteFooter = document.getElementById('infinite-footer');
    // const handleScrollInfiniteFooter = ( el ) => {
    //     if ( window.pageYOffset >= 350 ) {
    //         el.classList.add( 'okt-scrolled-bottom' );
    //     } else {
    //         el.classList.remove( 'okt-scrolled-bottom' );
    //     }
    // }
    // if ( infiniteFooter !== null ){
    //     window.addEventListener('scroll', () => {
    //         handleScrollInfiniteFooter( infiniteFooter );
    //     });
    // }

    const gotoFooter = document.getElementById('gotoFooter');
    if ( gotoFooter !== null ){
        gotoFooter.addEventListener('click', () => {
            // window.scrollTo({top: 0, behavior: 'smooth'});
            // document.getElementById('footer').scrollIntoView({ behavior: 'instant', block: 'start', inline: 'nearest' });
            window.scrollTo({top: ( document.getElementById('footer').offsetTop + document.documentElement.clientHeight * 0.5 ), behavior: 'smooth'});
        });
    }

    //
    const modalFooterContainer = document.getElementById('modalFooterContainer');
    if ( modalFooterContainer !== null ){
        let flagCloneFooter = false;
        modalFooterContainer.addEventListener('show.bs.modal', event => {
            if ( !flagCloneFooter ) {
                const modalFooterContent = document.getElementById('modalFooterContent');
                const footerClone = document.getElementById('footer').cloneNode(true);
                modalFooterContent.appendChild( footerClone );
                flagCloneFooter = true;
            }
        });
    }


    ////
    // likes

    $('[id*="oktlike_btn_"]').on('click', function(){

        let oktlike = $(this).data('oktlike');
        let okttype = $(this).data('okttype');

        $( '#oktlike_btn_' + oktlike ).blur();
        $( '#oktlike_btn_' + oktlike ).prop('disabled', true);
        $( '#oktlike_btn_' + oktlike ).html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>' +
            '  <span class="sr-only">Loading...</span>');

        const data = {
            'action': 'okt_likes_mark_as_liked',
            'nonce': $(this).data('nonce'),
            'okttype': okttype,
            'oktlike': oktlike,
        }

        let jqxhr = $.post(okt_likes_params.ajax_url, data, function(response) {
            let response_obj;

            if (typeof response == 'object') {
                response_obj = response;
            }
            else if (typeof response == 'string') {
                response_obj = JSON.parse(response);
            }

            if ( !response_obj.hasOwnProperty('status') || response_obj.status == 'error' ) {
                alert('Ha ocurrido un error inesperado. Por favor, recargue la página. ');
            }
            else {
                if ( response_obj.status == 'ok' ) {
                    if ( response_obj.hasOwnProperty('counter') ) {
                        $( '#oktlike_counter_' + oktlike ).html( '+' + response_obj.counter );
                    }
                    if ( okttype == 'like' ) {
                        $( '#oktlike_btn_' + oktlike ).html('<i class="bi bi-heart-fill"></i>');
                        $( '#oktlike_btn_' + oktlike ).removeClass('okt-btn-bookmark').addClass('okt-btn-bookmarked');
                        $( '#oktlike_btn_' + oktlike ).data('okttype', 'dislike');
                    }
                    else if ( okttype == 'dislike' ) {
                        $( '#oktlike_btn_' + oktlike ).html('<i class="bi bi-heart"></i>');
                        $( '#oktlike_btn_' + oktlike ).removeClass('okt-btn-bookmarked').addClass('okt-btn-bookmark');
                        $( '#oktlike_btn_' + oktlike ).data('okttype', 'like');
                        if ( $( '#oktlike_btn_' + oktlike ).closest('.okt-likes-row') ) {
                            $( '#oktlike_btn_' + oktlike ).closest('.okt-likes-row').slideUp( 400, function(){
                                $( '#oktlike_btn_' + oktlike ).closest('.okt-likes-row').remove();
                            });
                        }
                    }

                    // $( '#oktlike_btn_' + oktlike ).html('<i class="bi bi-hand-thumbs-up"></i>');

                    $( '#oktlike_btn_' + oktlike ).prop('disabled', false);
                }
            }
        });
    });

    ////
    // login
    $(window).on('load', function() {
        // todo same in other scripts
        if (typeof okt_login_params != 'undefined') {
            $('#okt_login_form').on('submit', function(evt){

                evt.preventDefault();
                evt.stopPropagation();
                $('#okt_submit_login').prop('disabled', true);
                $('#okt_form_message').addClass('d-none');

                if ( !document.getElementById('okt_login_form').checkValidity() ) {
                    console.log('Ajax Login : invalid username and/or password');
                    $('#okt_login_form').addClass('was-validated');
                    $('#okt_submit_login').prop('disabled', false);
                }
                else {
                    console.log('Ajax Login : valid username & password');
                    const data = {
                        'action': 'okt_login',
                        'nonce': $('#okt_login_security').val(),
                        'okt_username': $('#okt_username').val(),
                        'okt_password': $('#okt_password').val(),
                        'okt_rememberme': $('#okt_rememberme').val(),
                    }

                    let jqxhr = $.post(okt_login_params.ajax_url, data, function(response) {
                        let response_obj;
                        if (typeof response == 'object') {
                            response_obj = response;
                        }
                        else if (typeof response == 'string') {
                            response_obj = JSON.parse(response);
                        }
                        if ( !response_obj.hasOwnProperty('status') || response_obj.status == 'error' ) {
                            console.log('Ajax Login : return error');
                            alert('Ha ocurrido un error inesperado. Por favor, recargue la página. ');
                        }
                        else {
                            if ( response_obj.status == 'ok' ) {
                                location.reload();
                            }
                            else if ( response_obj.status == 'ko' ) {
                                $('#okt_form_message strong').text(response_obj.message);
                                $('#okt_form_message').removeClass('d-none');
                                $('#okt_login_form').removeClass('was-validated');
                                $('#okt_login_form').addClass('needs-validation');
                                $('#okt_submit_login').prop('disabled', false);
                            }
                        }
                    });
                }
            });
        }

        if (typeof okt_logout_params != 'undefined') {
            $('#okt_logout').on('click', function(evt){
                okt_logout(evt);
            });
            $('#okt_logout_my_data').on('click', function(evt){
                okt_logout(evt);
            });

            function okt_logout(evt) {
                evt.preventDefault();
                const data = {
                    'action': 'okt_logout',
                    'nonce': okt_logout_params.security,
                }
                let jqxhr = $.post(okt_logout_params.ajax_url, data, function(response) {

                    let response_obj;
                    if (typeof response == 'object') {
                        response_obj = response;
                    }
                    else if (typeof response == 'string') {
                        response_obj = JSON.parse(response);
                    }

                    // console.log( response_obj );


                    if ( !response_obj.hasOwnProperty('success') || response_obj.success !== true ) {
                        console.log('Ajax Login : return error');
                        alert('Ha ocurrido un error inesperado. Por favor, recargue la página. ');
                    }
                    else {
                        location.reload();
                    }

                });
            }

            if ( document.getElementById('okt_recover_password') ) {
                $('#okt_recover_password').on('click', function(evt){
                    evt.preventDefault();
                    const data = {
                        'action': 'okt_retrieve_password',
                        'nonce': okt_logout_params.security,
                    }
                    let jqxhr = $.post(okt_logout_params.ajax_url, data, function(response) {

                        let response_obj;
                        if (typeof response == 'object') {
                            response_obj = response;
                        }
                        else if (typeof response == 'string') {
                            response_obj = JSON.parse(response);
                        }

                        console.log( response_obj );

                        if ( !response_obj.hasOwnProperty('status') || response_obj.status == 'error' ) {
                            console.log('Ajax Login : return error');
                            alert('Ha ocurrido un error inesperado. Por favor, recargue la página. ');
                        }
                        else {
                            if ( response_obj.status == 'success' ) {
                                alert('Hemos enviado su solicitud de recuperación de contraseña al correo electrónico. ');
                            }
                        }


                    });
                });
            }

        }
    });


})(jQuery);

